import { formatTagFilterParam, parseTagFilterParam } from "@/tags/values"

import {
  parseMetadataFilters,
  serializeMetadataFilters,
} from "@/lib/metadataFilterSerialization"
import {
  parseMetricValueFilters,
  serializeMetricValueFilters,
} from "@/lib/metricValueFilters"
import type { FilterParamSchema } from "@/hooks/filter-params/types"

import type { FilterState } from "../types/filterState"

export const DEFAULT_RUNS_FILTER_STATE: FilterState = {
  searchValue: "",
  dateRange: { start: null, end: null },
  statusFilters: [],
  templateFilters: [],
  personaFilters: [],
  agentFilters: [],
  metricFilters: [],
  metricValueFilters: [],
  tagFilters: [],
  mutationFilters: [],
  testSetFilters: [],
  testCaseFilters: [],
  metadataFilters: [],
  scheduledJobFilters: [],
  sortDescriptor: { column: "createdAt", direction: "descending" },
}

export const RUNS_FILTER_PARAM_SCHEMA: FilterParamSchema<FilterState> = {
  searchValue: { type: "string", urlKey: "search" },
  dateRange: {
    type: "dateRange",
    urlKeys: { start: "date_start", end: "date_end" },
  },
  statusFilters: { type: "string[]", urlKey: "status" },
  templateFilters: { type: "string[]", urlKey: "template" },
  personaFilters: { type: "string[]", urlKey: "persona" },
  agentFilters: { type: "string[]", urlKey: "agent" },
  metricFilters: { type: "string[]", urlKey: "metric" },
  metricValueFilters: {
    type: "custom",
    urlKey: "metric_value_filters",
    serialize: serializeMetricValueFilters,
    parse: parseMetricValueFilters,
  },
  tagFilters: {
    type: "custom",
    urlKey: "tag",
    serialize: (value) => formatTagFilterParam(value) ?? "",
    parse: parseTagFilterParam,
  },
  mutationFilters: { type: "string[]", urlKey: "mutation" },
  testSetFilters: { type: "string[]", urlKey: "test_set" },
  testCaseFilters: { type: "string[]", urlKey: "test_case" },
  scheduledJobFilters: { type: "string[]", urlKey: "scheduled_job" },
  metadataFilters: {
    type: "custom",
    urlKey: "metadata_filters",
    serialize: (value) => serializeMetadataFilters(value ?? []),
    parse: parseMetadataFilters,
  },
  sortDescriptor: { type: "sort", urlKey: "sort" },
}
